import { apiRequest } from './queryClient';
import { ApiClient } from '@chefaiq/shared/lib/api-client';

export interface UserGuideMedia {
  _id: string;
  section: string;
  mediaType: 'image' | 'video';
  title: string;
  description?: string;
  url: string;
  thumbnailUrl?: string;
  order: number;
  isActive: boolean;
  uploadedBy?: {
    _id: string;
    name: string;
    email: string;
  };
  createdAt: string;
  updatedAt: string;
}

export async function getAllUserGuideMedia(): Promise<UserGuideMedia[]> {
  return apiRequest('GET', '/api/user-guide-media') as Promise<UserGuideMedia[]>;
}

export async function getMediaBySection(section: string): Promise<UserGuideMedia[]> {
  return apiRequest('GET', `/api/user-guide-media/section/${section}`) as Promise<UserGuideMedia[]>;
}

export async function uploadUserGuideMedia(formData: FormData): Promise<UserGuideMedia> {
  const token = ApiClient.getToken();
  const response = await fetch('/api/user-guide-media/upload', {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    },
    body: formData
  });
  
  if (!response.ok) {
    throw new Error('Upload failed');
  }
  
  return response.json();
}

export async function updateUserGuideMedia(
  id: string,
  updates: Partial<Pick<UserGuideMedia, 'title' | 'description' | 'order' | 'isActive'>>
): Promise<UserGuideMedia> {
  return apiRequest('PATCH', `/api/user-guide-media/${id}`, updates) as Promise<UserGuideMedia>;
}

export async function deleteUserGuideMedia(id: string): Promise<void> {
  return apiRequest('DELETE', `/api/user-guide-media/${id}`) as Promise<void>;
}

export async function replaceUserGuideMediaFile(id: string, file: File): Promise<UserGuideMedia> {
  const token = ApiClient.getToken();
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetch(`/api/user-guide-media/${id}/file`, {
    method: 'PUT',
    headers: { 'Authorization': `Bearer ${token}` },
    body: formData
  });
  if (!response.ok) throw new Error('File replacement failed');
  return response.json();
}

export async function deleteUserGuideMediaFile(id: string): Promise<UserGuideMedia> {
  const token = ApiClient.getToken();
  const response = await fetch(`/api/user-guide-media/${id}/file`, {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${token}` }
  });
  if (!response.ok) throw new Error('File deletion failed');
  return response.json();
}
